var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<li>\n    <a data-target=\"#\"\n       data-url=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Url") : depth0), depth0))
    + "\"\n       data-book=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Livro") : depth0), depth0))
    + "\"\n       data-page=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Relatorio") : depth0), depth0))
    + "\"\n       data-type=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"IdTipo") : depth0), depth0))
    + "\"\n       data-id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Id") : depth0), depth0))
    + "\">\n        "
    + alias2(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"Label") : depth0),{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":8,"column":8},"end":{"line":8,"column":22}}}))
    + "\n    </a>\n</li>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/navbar-reports-dropdown.hbs
// module id = igO2
// module chunks = 1